module.exports = require('omit-empty')
